/* eslint-disable prefer-destructuring */
export const API_SAVE_INTEGRATION_URL = '/api/integrations/facebook';
export const TEST_ID = 'facebook-slot';
export const APPCUES_ID = 'facebook-slot';
export const ID = 'facebook_ads';
export const SLOT_TITLE = 'Facebook Ads';
export const FIELDS = 'name,email,picture';
export const SCOPE = 'public_profile,ads_read,ads_management,pages_show_list';
export const FB_APP_ID = process.env.FB_APP_ID;
export const FB_API_VERSION = process.env.FB_API_VERSION;
